
export default [
  {
    header: '—— แต้มสะสม ——',
  },
  {
    title: 'แต้มสะสม',
    route: 'point-balance',
    icon: 'StarIcon',
  },
  {
    title: 'แลกแต้ม',
    route: 'exchange-point',
    icon: 'AwardIcon',
  },
]
